import PropTypes from 'prop-types';
import React from 'react';
import { parseHtml } from '../../utils/util';

const getVal = require('lodash/get');
/**
 * returns Dynamic List component
 * @param {*} props
 */
const List = (props) => {
  const {
    cssProperties,
    fieldLabel,
    fieldId,
    isDynamicList = false,
    preFillListWith = '',
    preFillSubListWith = '',
    dataObject,
  } = props;

  let listNodes = [];
  let subListNodes = [];

  if (isDynamicList) {
    listNodes = getVal(dataObject, preFillListWith) || [];
    subListNodes = getVal(dataObject, preFillSubListWith) || [];
  } else {
    listNodes = fieldLabel.listNodes || [];
    subListNodes = fieldLabel.subListNodes || [];
  }

  const orderedList = (nodes = [], subNodes = []) => (
    <ol className="body-3">
      {
          nodes.map((node, index) => (
            <li className={fieldLabel.cssProperties} style={{ listStyle: `${fieldLabel.style ? fieldLabel.style : 'inherit'}` }} key={node}>{fieldLabel.nodeIcon && <span className="badge dls-color-neutral-bg filled margin-1-r">{index + 1}</span>}
              {parseHtml(node)}
              {
                subNodes && subNodes.length > 0 && (
                  <ul className="body-3">
                    {
                      subNodes
                      && subNodes.map((subNode) => (
                        <li className={fieldLabel.cssProperties} key={fieldId}>
                          {parseHtml(subNode)}
                        </li>
                      ))
                    }
                  </ul>
                )
              }
            </li>
          ))
        }
    </ol>
  );

  const unorderedList = (nodes = [], subNodes = []) => (
    <ul className="body-3">
      {
          nodes.map((node, index) => (
            <li className={fieldLabel.cssProperties} style={{ listStyle: `${fieldLabel.style ? fieldLabel.style : 'inherit'}` }} key={node}>{fieldLabel.nodeIcon && <span className="badge dls-color-neutral-bg filled margin-1-r">{index + 1}</span>}
              {parseHtml(node)}
              {
                subNodes && subNodes.length > 0 && (
                  <ul className="body-3">
                    {
                      subNodes
                      && subNodes.map((subNode) => (
                        <li className={fieldLabel.cssProperties} key={fieldId}>
                          {parseHtml(subNode)}
                        </li>
                      ))
                    }
                  </ul>
                )
              }
            </li>
          ))
        }
    </ul>
  );

  return (
    <div className={cssProperties.style}>
      {fieldLabel && fieldLabel.orderedList
        ? orderedList(listNodes, subListNodes)

        : unorderedList(listNodes, subListNodes)}
    </div>
  );
};

List.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  isDynamicList: PropTypes.bool,
  preFillListWith: PropTypes.string,
  preFillSubListWith: PropTypes.string,
  dataObject: PropTypes.objectOf(PropTypes.shape),
};

export default List;
